angular.module('unica_notification_template.notification_template_services', []);